export const SALE_STATUSES = [
  { v: "pendiente", l: "Pendiente" },
  { v: "pagada", l: "Pagada" },
  { v: "cancelada", l: "Cancelada" },
];

export const QUOTE_STATUSES = [
  { v: "borrador", l: "Borrador" },
  { v: "enviada", l: "Enviada" },
  { v: "aprobada", l: "Aprobada" },
  { v: "rechazada", l: "Rechazada" },
];

export const JOB_STATUSES = [
  { v: "pendiente", l: "Pendiente" },
  { v: "en_proceso", l: "En proceso" },
  { v: "terminado", l: "Terminado" },
  { v: "entregado", l: "Entregado" },
];

export const TOOL_STATUSES = [
  { v: "disponible", l: "Disponible" },
  { v: "en_uso", l: "En uso" },
  { v: "reparacion", l: "En reparación" },
];

export const UNITS = ["pieza", "hoja", "m²", "m", "tramo", "pie tablar", "litro", "galón", "kg", "caja"];

const TONE = {
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  blue: "bg-blue-50 text-blue-700 border-blue-200",
  red: "bg-red-50 text-red-700 border-red-200",
  amber: "bg-amber-50 text-amber-800 border-amber-200",
  stone: "bg-stone-100 text-stone-700 border-stone-200",
};

export const STATUS_TONE = {
  pendiente: TONE.amber, pagada: TONE.green, cancelada: TONE.red,
  borrador: TONE.stone, enviada: TONE.blue, aprobada: TONE.green, rechazada: TONE.red,
  en_proceso: TONE.blue, terminado: TONE.green, entregado: TONE.stone,
  disponible: TONE.green, en_uso: TONE.blue, reparacion: TONE.red,
};

export const STATUS_LABEL = Object.fromEntries(
  [...SALE_STATUSES, ...QUOTE_STATUSES, ...JOB_STATUSES, ...TOOL_STATUSES].map((s) => [s.v, s.l])
);

export const DOC_TYPES = {
  sale: {
    endpoint: "/sales", base: "/ventas", title: "Notas de venta", single: "Nota de venta",
    pdfTitle: "NOTA DE VENTA", statuses: SALE_STATUSES, defaultStatus: "pendiente",
  },
  quote: {
    endpoint: "/quotes", base: "/cotizaciones", title: "Cotizaciones", single: "Cotización",
    pdfTitle: "COTIZACIÓN", statuses: QUOTE_STATUSES, defaultStatus: "borrador",
  },
};
